import React, { useCallback } from 'react'

import { BsrsGrid, EnumFilterCell, EnumCell, NameColumn, actionButtonsColumnProps, DateCell, DateFilterCell } from '@/components/BsrsGrid'
import { GridColumn as Column } from '@progress/kendo-react-grid'
import context from '@/context'
import { personTypes } from '@/enums/PersonTypes'
import { InstitutionSearchList } from '@/internal-app/components/institutionSearchList'
import { useLocalization } from '@/hooks/localization'

function Fines (_) {
  const { localize, locale } = useLocalization()

  const renderGrid = useCallback((personId, lastReloadedAt) => {
    const enumName = personTypes.enumName
    return (
      <BsrsGrid
        persistenceId={'fines'}
        dataSource={(request, options) => context.api.fineService.getTableData(personId, request, options)}
        filterable
        lastReloadedAt={lastReloadedAt}>
        <Column field='personName' title={localize('Blacklists.PersonName')} editable={false} />
        <Column field='personLatinName' title={localize('Blacklists.PersonLatinName')} editable={false} />
        {NameColumn({ locale, nameProp: 'penaltySourceName', latinNameProp: 'penaltySourceLatinName', title: localize('Fines.Type'), editable: false })}
        <Column field='personType' title={localize('Blacklists.PersonType')} editable={false}
          cell={EnumCell({ localize, enumName })}
          filterCell={EnumFilterCell({ localize, enumName }, personTypes.values.filter(x => x !== personTypes.enum.Unknown))} enumName={enumName} />

        <Column field='amount' title={localize('Common.Amount')} filter='numeric' editable={false} />
        <Column field='date' title={localize('Common.Date')} filter='date' cell={DateCell} filterCell={DateFilterCell} editable={false} />
        <Column {...actionButtonsColumnProps([{ url: x => `/fines/${x.id}`, icon: 'pencil' }])} />
      </BsrsGrid>
    )
  }, [locale, localize])

  return <InstitutionSearchList renderGrid={renderGrid} title={'Fines.FinesTitle'} scope={'Fines'} createNewButtonText={'Fines.CreateNew'} />
}

export default Fines



// WEBPACK FOOTER //
// ./src/internal-app/pages/fines/list.js